<template>
  <b-sidebar
    id="sidebar-accept-rejected-doc"
    sidebar-class="sidebar-lg"
    bg-variant="white"
    shadow
    backdrop
    no-header
    right
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          {{ $t('Accepted') }}
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="clear(hide)"
        />
      </div>
      <validation-observer ref="acceptedApplyDocument">
        <!-- Body -->
        <b-form
          class="p-2"
          @submit.prevent
        >

          <b-form-group
            :label="$t('Accepted info')"
            label-for="accepted-info"
          >
            <validation-provider
              #default="{ errors }"
              :name="$t('Accepted info')"
              rules="required"
            >
              <b-form-textarea
                id="accepted-info"
                v-model="accepted_info"
                trim
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

          <!-- Form Actions -->
          <div class="d-flex mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="success"
              class="mr-2"
              type="submit"
              @click="submit(hide)"
            >
              {{ $t('Accepted') }}
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              variant="outline-secondary"
              @click="clear(hide)"
            >
              {{ $t('Cancel') }}
            </b-button>
          </div>
        </b-form>
      </validation-observer>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar, BForm, BFormGroup, BFormTextarea, BButton,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import { required } from '@/libs/validations/validations'

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormTextarea,
    BButton,
    ValidationObserver,
    ValidationProvider,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      accepted_info: '',
      required,
    }
  },
  computed: {
    applyDocument() {
      return this.$store.state[this.MODULE_NAME].applyDocument
    },
  },
  mounted() {
    localize(this.$i18n.locale)
  },
  methods: {
    clear(hide) {
      this.accepted_info = ''
      hide()
    },
    submit(hide) {
      this.$refs.acceptedApplyDocument.validate().then(success => {
        if (success) {
          this.$removeSwal(this, {
            id: this.applyDocument.id,
            body: {
              status: this.$store.state.staticModule.applyDocumentStatusAccepted,
              rejected_info: this.accepted_info,
            },
          }, `${this.MODULE_NAME}/patch`, () => {
            this.$emit('refetchData')
            this.accepted_info = ''
            hide()
          }, {
            text: '',
            confirmButtonText: 'Yes, accept it!',
            successTitle: 'Accepted!',
            successText: 'This apply document has been accepted.',
            errorText: 'This apply document has not been accepted.',
          })
        }
      })
    },
  },
  setup() {
    const MODULE_NAME = 'applyDocument'
    return {
      MODULE_NAME,
    }
  },
}
</script>
